<template lang="pug">
  v-card.pinCodeForm
    v-card-title
      h2.head-title Введите пин-код
    v-card-text
      v-layout(row justify-center)
        v-flex(xs12)
          v-form(@submit.prevent="getToken")
            div.field-group
              v-text-field(
                mask="#",
                solo,
                flat,
                :maxlength="1",
                :error="hasError",
                name="digit_1",
                ref="digit_1",
                v-model="pin.digit_1",
                autocomplete="off",
                type="password")
              v-text-field(
                mask="#",
                solo,
                flat,
                :maxlength="1",
                :error="hasError",
                name="digit_2",
                ref="digit_2",
                v-model="pin.digit_2",
                autocomplete="off",
                type="password")
              v-text-field(
                mask="#"
                solo,
                flat,
                :maxlength="1",
                :error="hasError",
                name="digit_3",
                ref="digit_3",
                v-model="pin.digit_3",
                autocomplete="off",
                type="password")
              v-text-field(
                mask="#"
                solo,
                flat,
                :maxlength="1",
                :error="hasError",
                name="digit_4",
                ref="digit_4",
                v-model="pin.digit_4",
                autocomplete="off",
                type="password")
            span(
              v-show="hasError").error-text {{ errorText }}
            v-layout(justify-center)
              v-btn(
                large
                id="pinCodeBtn",
                color="primary",
                ref="sigIn",
                type="submit",
                :loading="pinConfirmLoading",
                :disabled="isDisableBtn") Войти
</template>

<script>
export default {
  name: 'Pincode',
  data() {
    return {
      pin: {
        digit_1: null,
        digit_2: null,
        digit_3: null,
        digit_4: null
      },
      hasError: false,
      errorText: '',
      isDisableBtn: true,
      code: ''
    }
  },
  mounted() {
    this.$store.dispatch('SHOW_BACK_BTN', true)
    this.$refs.digit_1.$refs.input.focus()
  },
  watch: {
    'pin.digit_1'(val) {
      if (val) this.$refs.digit_2.focus()
    },
    'pin.digit_2'(val) {
      if (val) this.$refs.digit_3.focus()
      else this.$refs.digit_1.focus()
    },
    'pin.digit_3'(val) {
      if (val) this.$refs.digit_4.focus()
      else this.$refs.digit_2.focus()
    },
    'pin.digit_4'(val) {
      if (!val) this.$refs.digit_3.focus()
    },
    fullPin(val) {
      this.isDisableBtn = val.length !== 4
    }
  },
  computed: {
    fullPin() {
      return this.pin.digit_1 + this.pin.digit_2 + this.pin.digit_3 + this.pin.digit_4
    },
    pinConfirmLoading() {
      return this.$store.state.auth.loading.pinConfirmLoading
    }
  },
  methods: {
    getToken() {
      const pin = { pin: this.pin.digit_1 + this.pin.digit_2 + this.pin.digit_3 + this.pin.digit_4 }
      const data = { pin: pin.pin }
      this.$store.dispatch('GET_TOKEN', data).then(() => {
        // let approve = this.$store.state.auth.checkPinResponse.approve
        let error = this.$store.state.auth.errors.checkPinError
        if (error) {
          this.hasError = true
          this.errorText = error.message
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  padding: 32px 16px;
  &__text {
    padding: 0;
    .v-form {
      .field-group {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 0 auto 80px;
        .v-input {
          margin: 0 10px;
          max-width: 60px;
          width: 100%;
        }
      }
    }
    .error-text {
      text-align: center;
      color: #ff333b;
      font-size: 1rem;
      font-weight: 400;
      display: inline-block;
      position: absolute;
      bottom: 120px;
      left: 50%;
      right: 50%;
      max-width: 362px;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
    }
  }
  #pinCodeBtn {
    border-radius: 4px;
    max-width: 190px;
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .v-card {
    &__text {
      .v-form {
        .field-group {
          .v-input {
            margin: 0 5px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AuthPages/Pincode.vue